import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  CustomerDropDown,
  DropDown,
  Loader,
  TabSelector,
} from "@src/components/atoms";
import { useAdminContext } from "@src/context/adminContext";
import { UsersSection } from "../shared/UsersSection";

const UsersPage = () => {
  const { selectedCustomer } = useAdminContext();

  return (
    <div className="p-2 flex flex-col gap-4">
      <h2 className="text-center p-2">Operators</h2>

      <div className="my-4">
        <CustomerDropDown />
      </div>
      {selectedCustomer != null && (
        <UsersSection customerCode={selectedCustomer.customerCode} />
      )}
    </div>
  );
};

export default UsersPage;
